import { axios } from "../../util/axiosConfig";
import { cities } from "../urls";

const getGeoJson = name => axios.get(cities.geoJson(name)).then(response => response.data);

export default getGeoJson;
